import { createContext, useMemo } from 'react'
import { VEHICLE_TYPES, VEHICLE_URL_CONFIG } from '../config'

const VehicleContext = createContext()

// Helper function to determine vehicle type from URL
const getVehicleTypeFromUrl = (url) => {
  for (const config of VEHICLE_URL_CONFIG) {
    const urlIncludes = config.urls.includes || []
    const urlExcludes = config.urls.excludes || []
    const urlIsIncluded =
      urlIncludes.length > 0 ? urlIncludes.some((include) => url.includes(include)) : true
    const urlIsExcluded =
      urlExcludes.length > 0 ? urlExcludes.some((exclude) => url.includes(exclude)) : false

    if (urlIsIncluded && !urlIsExcluded) {
      return config.vehicleType
    }
  }

  // todoCT: consider a hard fallback? Logs to assist debugging prod
  console.warn('No vehicle type found for URL: ', url)
  console.warn('Using default vehicle type: ', VEHICLE_TYPES.OUTLANDER.index)
  // Default to outlander if no match found
  return VEHICLE_TYPES.OUTLANDER.index
}

// Vehicle Context Provider
export const VehicleProvider = ({ children }) => {
  const currentUrl = window.location.pathname

  const vehicleContext = useMemo(() => {
    const vehicleType = getVehicleTypeFromUrl(currentUrl)

    return {
      vehicleType,
      currentUrl,
    }
  }, [currentUrl])
  console.log('---', vehicleContext)
  return <VehicleContext.Provider value={vehicleContext}>{children}</VehicleContext.Provider>
}

export default VehicleContext
